var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"nkr-code-link",attrs:{"title":`Ver ${_vm.code}`},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.openProduct(_vm.code)}}},[_vm._v(_vm._s(_vm.code))])
}
var staticRenderFns = []

export { render, staticRenderFns }